// Lives here rather than in @rmh/i18n so non-Next consumers - lambdas, route
// validation in @rmh/utils - can reason about locale-prefixed paths without
// pulling next-intl into their bundle. @rmh/i18n builds its routing config
// from these.
export const LOCALES = ["en", "es"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";
